const BLOCKED_URL_PROTOCOL = /^(javascript|data|vbscript):/i;
const HTTP_URL_PROTOCOL = /^https?:\/\//i;

/** Normalize user-entered contract links to safe http(s) URLs. */
export function normalizeContractLinkUrl(url: string): string {
  const trimmed = (url || '').trim();
  if (!trimmed || BLOCKED_URL_PROTOCOL.test(trimmed)) {
    return '';
  }

  let candidate = HTTP_URL_PROTOCOL.test(trimmed) ? trimmed : `https://${trimmed}`;
  if (BLOCKED_URL_PROTOCOL.test(candidate.replace(/^https?:\/\//i, ''))) {
    return '';
  }

  try {
    const parsed = new URL(candidate);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return '';
    }
    return parsed.href;
  } catch {
    return '';
  }
}

/** UTF-8 safe base64 encoding for payload snapshots (replaces deprecated unescape). */
export function encodeUtf8ToBase64(value: string): string {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
